import P from '../../pages';
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { defaultMessages } from '../../../../libs/i18n/default';
import ReactOnRails from 'react-on-rails';
import FormHeader from './FormHeader';
import Redirector from './Redirector';
import ButtonGroup from './ButtonGroup';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import FormControl from 'react-bootstrap/lib/FormControl';
import ReactMarkdown from 'react-markdown';
import CustomFormGroup from './CustomFormGroup';
import { validator, pageValid, executeValidations } from '../../validator';
import { changeState } from '../../utilities';

class Referral extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      referringHostName: { val: this.props.user.host.referring_host_name, validationKey: 'attributes_referring_host_name' },
      referringHostPostcode: { val: this.props.user.host.referring_host_postcode, validationKey: 'attributes_referring_host_postcode' },
    };
    this.submit = this.submit.bind(this);
    this.back = this.back.bind(this);
    this.changeState = this.changeState.bind(this);
  }

  componentWillMount(){
    executeValidations(this)
  }

  changeState = async(id, val) => {
    changeState(this, id, val)
  }

  back(e) {
    this.props.onGoBack();
  }

  submit(e) {
    this.props.onReferralSubmit({
      authenticity_token: ReactOnRails.authenticityToken(),
      referring_host: {
        name: this.state.referringHostName.val,
        postcode: this.state.referringHostPostcode.val
      }
    });
  }

  referralContent(){
    const referralContent = this.props.referralProgram.content;
    return (referralContent ? <ReactMarkdown source={referralContent}/> : null);
  }

  render() {
    const thisPage = P.REFERRAL_PAGE;
    const { formatMessage } = this.props.intl;
    const content = this.props.content;
    const page = this.props.page;
    const title = this.props.referralProgram.title || 'Referral'
    const nameFieldLabel = this.props.referralProgram.name_field_label || 'Who referred you?'
    const postcodeFieldLabel = this.props.referralProgram.postcode_field_label || 'What is their postcode?'

    return (
      <div id={page} className='profile'>
        <Redirector this_page={thisPage} page={page}/>

        <form onSubmit={this.submit}>
          <FormHeader title={`# ${title}`}/>
          {this.referralContent()}

          <CustomFormGroup valid={this.state.referringHostName.valid}>
            <ControlLabel>{nameFieldLabel}</ControlLabel>
            <FormControl
              placeholder={formatMessage(defaultMessages.clientHostPagesReferralPlaceholdersName)}
              type="text"
              componentClass="input"
              id="referringHostName"
              defaultValue={this.state.referringHostName.val}
              onChange={e => this.changeState(e.target.id, e.target.value)} />
          </CustomFormGroup>

          <CustomFormGroup valid={this.state.referringHostPostcode.valid}>
            <ControlLabel>{postcodeFieldLabel}</ControlLabel>
            <FormControl
              placeholder={formatMessage(defaultMessages.clientHostPagesReferralPlaceholdersPostcode)}
              type="text"
              componentClass="input"
              id="referringHostPostcode"
              defaultValue={this.state.referringHostPostcode.val}
              onChange={e => this.changeState(e.target.id, e.target.value)} />
          </CustomFormGroup>

          <ButtonGroup
            backFunc={this.back}
            skipFunc={this.skip}
            submitFunc={this.submit}
            page={thisPage}
            user={this.props.user}
            intl={this.props.intl}
            disableSubmit={!pageValid(this.state, this.props.requiredFields)} />

        </form>
      </div>
    );
  }
}

Referral.propTypes = {
   onReferralSubmit: PropTypes.func,
   onSkipSubmit: PropTypes.func,
   onGoBack: PropTypes.func,
   page: PropTypes.string,
   intl: PropTypes.object,
   content: PropTypes.object
};

export default injectIntl(Referral);
